import { RELOAD_ACTIVITIES } from '../Actions/actionName'

const ReloadActivitiesReducer = (state = [], action) => {
  switch (action.type) {
    case RELOAD_ACTIVITIES:
      return action.payload;
    default:
      return state;
  }
};

export default ReloadActivitiesReducer;
